import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FileUploadResponseDto } from 'src/app/data/models/dto/file-upload-response.dto';

import { environment } from '../../config/environments/environment';
import { FileResponse } from '../models/dto/file-response';
import { FileDto } from '../models/dto/file.dto';

@Injectable()
export class FileService {
  private readonly filesCollection = 'files';
  private readonly downloadUrl = 'download';

  constructor(private http: HttpClient) {}

  upload(files: File[], filePath: string): Observable<string> {
    const formData = new FormData();
    files.forEach((f) => {
      formData.append('files', f);
    });
    formData.append('path', filePath);
    return this.http.post(`${environment.api.baseUrl}/files/upload`, formData, {
      responseType: 'text',
    });
  }

  uploadV3(files: File[], filePath: string): Observable<FileUploadResponseDto> {
    const formData = new FormData();
    files.forEach((f) => {
      formData.append('files', f);
    });
    formData.append('path', filePath);
    return this.http.post<FileUploadResponseDto>(
      `${environment.api.baseUrl}/files/v3/upload`,
      formData
    );
  }

  uploadOldStructure(
    files: File[],
    oldStructurefilePath: string
  ): Observable<HttpEvent<string>> {
    const formData = new FormData();
    files.forEach((f) => {
      formData.append('files', f);
    });
    formData.append('path', oldStructurefilePath);
    const url = `${environment.api.baseUrl}/files/upload`;
    const req = new HttpRequest('POST', url, formData, {
      reportProgress: true,
      responseType: 'text',
    });
    return this.http.request(req);
  }

  uploadNewStructure(
    files: File[]
  ): Observable<HttpEvent<FileUploadResponseDto>> {
    const formData = new FormData();
    files.forEach((f) => {
      formData.append('files', f);
    });
    const url = `${environment.api.baseUrl}/files/v3/upload`;
    const req = new HttpRequest('POST', url, formData, {
      reportProgress: true,
      responseType: 'json',
    });
    return this.http.request(req);
  }

  /**
   * @deprecated
   */
  download(path: string): Observable<FileResponse> {
    return this.http.get<FileResponse>(
      `${environment.api.baseUrl}/${this.filesCollection}/${
        this.downloadUrl
      }?path=${encodeURIComponent(path)}`
    );
  }

  downloadByUrlPath(urlPath: string): Observable<ArrayBuffer> {
    let pathArr = urlPath.split('/');
    let fileName = pathArr.pop();
    if (fileName) {
      fileName = encodeURIComponent(fileName);
      pathArr.push(fileName);
    }
    const url = pathArr.join('/');

    return this.http
      .get(url, {
        responseType: 'arraybuffer',
      })
      .pipe(map((file: ArrayBuffer) => file));
  }

  delete(id: string): Observable<any> {
    return this.http.delete(`${environment.api.baseUrl}/files/${id}`);
  }

  getById(id: string): Observable<FileDto> {
    return this.http.get<FileDto>(`${environment.api.baseUrl}/files/${id}`);
  }
}
